// 注意：同步/覆盖本文件时，请勿删除 data-pc-slides 相关逻辑。
// 按 group 覆盖 PC slidesPerView，配置来自 child_pc_slides_by_group（见 p-sale-swiper.liquid）。
document.addEventListener("DOMContentLoaded", () => {
  if (customElements.get("p-sale-swiper")) return;

  class PSaleSwiper extends HTMLElement {
    constructor() {
      super();
      this.$this = $(this);
      this.childSwiperInstances = [];
      this.childPcEnableSwiper = this.$this.data("child-pc-enable-swiper");
      this.childMbEnableSwiper = this.$this.data("child-mb-enable-swiper");
      this.childPcSlides = this.$this.data("child-pc-slides");
      this.childPcSlidesGroup = this.$this.data("child-pc-slides-group");
      this.childMbSlides = this.$this.data("child-mb-slides");
      this.childPcGap = this.$this.data("child-pc-gap");
      this.childMbGap = this.$this.data("child-mb-gap");
      this.childShowPagination = this.$this.data("child-show-pagination");
      this.childShowNavigation = this.$this.data("child-show-navigation");
      this.childEnableSlidesOffset = this.$this.data("child-slides-offset");
      this.$groupSwiperContainer = this.$this.find(".p-sale-swiper-groups-container");
      this.$groupNamesWrapper = this.$this.find(".p-sale-swiper-groups-names-wrapper");
      this.$fixedProductContainer = this.$this.find(".p-sale-swiper-fixed-product-container");

      this.handleGroupChange = this.handleGroupChange.bind(this);
    }

    connectedCallback() {
      this.initFixedProduct();
      this.initGroupSwiper();
      this.initChildSwiper();
      let resizeTimer = null;
      const self = this;
      let lastWidth = window.innerWidth;
      $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          const currentWidth = window.innerWidth;
          if (currentWidth === lastWidth) return;
          self.rebuildSwipers();
          lastWidth = currentWidth;
        }, 200);
      });
    }

    disconnectedCallback() {
      this.destroySwipers();
    }

    initFixedProduct() {
      if (this.$fixedProductContainer.length > 0) {
        this.$fixedProductContainer.each((_, container) => {
          const $container = $(container);

          const $targets = $container.parent().find(".p-sale-swiper-fixed-product");

          $container.append($targets);
        });
      }
    }

    initGroupSwiper() {
      if (this.$groupNamesWrapper.length > 0 && this.$groupSwiperContainer.length > 0) {
        const params = {
          slidesPerView: 1,
          allowTouchMove: false,
          spaceBetween: 10,
          autoHeight: true,
        };
        this.groupSwiperInstance = new Swiper(this.$groupSwiperContainer[0], params);
        this.initGroupSwiperNameEvent();
      }
    }

    initGroupSwiperNameEvent() {
      if (this.$groupNamesWrapper.length > 0 && this.groupSwiperInstance) {
        const self = this;
        this.handleGroupChange(0);
        this.$groupNamesWrapper.on("click", ".p-sale-swiper-group-name", function () {
          const index = $(this).data("index");
          self.handleGroupChange(index);
        });
      }
    }

    // 轮播数量不足以超出一屏时，隐藏分页/箭头（即使后台开了 Show Pagination / Navigation）
    setChildControlsVisible($group, visible) {
      const $pagination = $group.find(".swiper-pagination");
      const $buttons = $group.find(".p-sale-bundle-swiper-buttons-container");
      $pagination.css("display", visible ? "" : "none");
      $buttons.css("display", visible ? "" : "none");
    }

    initChildSwiper() {
      const enableSwiper = window.innerWidth > 850 ? this.childPcEnableSwiper : this.childMbEnableSwiper;
      const $container = this.$this.find(".p-sale-swiper-children-container");
      const $wrapper = $container.find(".p-sale-swiper-children-wrapper");
      const $item = $wrapper.find(".p-sale-swiper-children-product-item");
      if (enableSwiper) {
        $container.addClass("swiper-container");
        $wrapper.addClass("swiper-wrapper");
        $item.addClass("swiper-slide");
        $container.each((i, childrenContainer) => {
          const $childrenContainer = $(childrenContainer);
          const $group = $childrenContainer.parent();
          // 只统计可滑动商品，不含 fixed 大卡
          const itemCount = $childrenContainer.find(
            ".p-sale-swiper-children-wrapper .p-sale-swiper-children-product-item"
          ).length;
          const groupPcSlides = Number($childrenContainer.closest("[data-pc-slides]").attr("data-pc-slides"));
          const pcSlides = Number.isFinite(groupPcSlides) && groupPcSlides > 0 ? groupPcSlides : this.childPcSlides;
          const slidesPerView = window.innerWidth > 850 ? pcSlides : this.childMbSlides;
          const needsControls = slidesPerView < itemCount;
          this.setChildControlsVisible($group, needsControls);
          const params =
            window.innerWidth > 850
              ? {
                  slidesPerView: pcSlides,
                  spaceBetween: this.childPcGap,
                  slidesPerGroup: this.childPcSlidesGroup,
                  allowTouchMove: this.childEnableSlidesOffset ? true : needsControls,
                }
              : {
                  slidesPerView: this.childMbSlides,
                  spaceBetween: this.childMbGap,
                  allowTouchMove: this.childEnableSlidesOffset ? true : needsControls,
                };
          // 商品数超过一屏时不要让 Swiper 把上一页/下一页都标成 disabled
          params.watchOverflow = !needsControls;
          if (!Number.isFinite(this.childPcSlidesGroup) || this.childPcSlidesGroup <= 0) {
            delete params.slidesPerGroup;
          }
          if (this.childEnableSlidesOffset || window.innerWidth < 850) {
            const offsetValue = this.getSwiperOffset();
            params.slidesOffsetBefore = offsetValue;
            if (window.innerWidth < 850) {
              params.slidesOffsetAfter = offsetValue;
            }
          }
          if (this.childShowPagination && needsControls) {
            params.pagination = {
              el: $group.find(".swiper-pagination")[0],
              clickable: true,
              type: "bullets",
            };
          }
          if (this.childShowNavigation && needsControls) {
            const $buttons = $group.find(".p-sale-bundle-swiper-buttons-container");
            params.navigation = {
              nextEl: $buttons.find(".swiper-button-next")[0],
              prevEl: $buttons.find(".swiper-button-prev")[0],
            };
          }
          this.childSwiperInstances[i] = new Swiper(childrenContainer, params);
        });
      } else {
        $container.removeClass("swiper-container");
        $wrapper.removeClass("swiper-wrapper");
        $item.removeClass("swiper-slide");
        $container.each((_, childrenContainer) => {
          this.setChildControlsVisible($(childrenContainer).parent(), false);
        });
      }
    }

    destroySwipers() {
      if (this.groupSwiperInstance && !this.groupSwiperInstance.destroyed) {
        this.groupSwiperInstance.off("slideChange.fixed");
        this.groupSwiperInstance.destroy(true, true);
        this.groupSwiperInstance = null;
      }
      if (Array.isArray(this.childSwiperInstances) && this.childSwiperInstances.length > 0) {
        this.childSwiperInstances.forEach((instance) => {
          instance.off("slideChange.fixed");
          instance.destroy(true, true);
          instance = null;
        });
        this.childSwiperInstances = [];
      }
    }

    rebuildSwipers() {
      this.destroySwipers();
      this.initGroupSwiper();
      this.initChildSwiper();
    }

    handleGroupChange(index) {
      this.groupSwiperInstance.slideTo(index);

      const $items = this.$groupNamesWrapper.find(".p-sale-swiper-group-name");
      const $active = $items.removeClass("is-active").eq(index).addClass("is-active");

      const container = this.$groupNamesWrapper.parent()[0]; // container
      const item = $active[0];

      if (!container || !item) return;

      const containerWidth = container.clientWidth;
      const itemLeft = item.offsetLeft;
      const itemWidth = item.offsetWidth;

      const target = itemLeft - containerWidth / 2 + itemWidth / 2;

      const maxScroll = container.scrollWidth - containerWidth;
      const finalScroll = Math.max(0, Math.min(target, maxScroll));

      container.scrollTo({
        left: finalScroll,
        behavior: "smooth",
      });
    }

    getSwiperOffset() {
      const cssOffset = getComputedStyle(document.documentElement)
        .getPropertyValue("--p-common-wrapper-half-padding")
        .trim();
      const el = document.createElement("div");
      el.style.position = "absolute";
      el.style.visibility = "hidden";
      el.style.pointerEvents = "none";
      el.style.width = `${cssOffset}`;

      document.body.appendChild(el);
      const value = el.getBoundingClientRect().width;
      document.body.removeChild(el);

      return value;
    }
  }

  customElements.define("p-sale-swiper", PSaleSwiper);
});
